import { render, staticRenderFns } from "./addold.vue?vue&type=template&id=5b2b630c&scoped=true"
import script from "./addold.vue?vue&type=script&lang=js"
export * from "./addold.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b2b630c",
  null
  
)

export default component.exports